import React from "react";
import { Button, Typography, Space, ConfigProvider, Spin } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useTherapistController } from "../../../../hooks/revi/useTherapistController";
// Importar desde el index (barril) que crearás
import { TherapistList } from "../../../../components/Admin/TherapistCmp/TherapistList/TherapistList";
import { TherapistFormModal } from "../../../../components/Admin/TherapistCmp/TherapistForm/TherapistFormModal";
import "./Page_Institution_Therapists.scss";

const { Title, Text } = Typography;

export function Page_Institution_Therapists() {
  const { t } = useTranslation("institution");

  const {
    therapists,
    pagination,
    loading,
    showModal,
    editingTherapist,
    institutionId,
    loadTherapists,
    openNewModal,
    openEditModal,
    closeModal,
    handleDelete,
    handleUnlinkPatient,
  } = useTherapistController();

  return (
    <ConfigProvider>
      <div className="page-institution-therapists">
        {/* Cabecera con Acción */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 32,
          }}
        >
          <Space orientation="vertical" size={2}>
            <Title level={2} style={{ margin: 0 }}>
              {t("therapists.page.title")}
            </Title>
            <Text type="secondary">{t("therapists.page.subtitle")}</Text>
          </Space>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            size="large"
            onClick={openNewModal}
          >
            {t("therapists.page.new")}
          </Button>
        </div>

        {/* Contenido Principal */}
        {loading && therapists.length === 0 ? (
          <div style={{ padding: 50, textAlign: "center" }}>
            <Spin size="large" />
          </div>
        ) : (
          <TherapistList
            therapists={therapists}
            pagination={pagination}
            loading={loading}
            onPageChange={(page) => loadTherapists(page)}
            onEdit={openEditModal}
            onDelete={handleDelete}
            onUnlinkPatient={handleUnlinkPatient}
          />
        )}

        {/* Modal Formulario */}
        <TherapistFormModal
          visible={showModal}
          onClose={closeModal}
          therapist={editingTherapist}
          institutionId={institutionId}
          onSuccess={() => loadTherapists(pagination.page)}
        />
      </div>
    </ConfigProvider>
  );
}
